export class SettingsModel {
    logo: ImageBitmap;
    backgroundColorStart: string;
    backgroundColorEnd: string;
    textColor: string;

    constructor(logo = new ImageBitmap, backgroundColorStart ='', backgroundColorEnd = '', textColor = '') {
        this.logo = logo;
        this.backgroundColorStart = backgroundColorStart;
        this.backgroundColorEnd = backgroundColorEnd;
        this.textColor = textColor;
    }
}
